import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Login from "./Screen/Login/login";
import SuperAdminDashBoard from "./Screen/Superadmin/superAdminDashboard";
import AdminDashboard from "./Screen/Admin/adminDashboard";
import CxoDashboard from "./Screen/CXO/cxoDashboard";
import PublicationDashBoard from "./Screen/Publication/publicationDashboard";
import SuccessSnackbar from "./Component/successSankbar";
import { set } from "./store/slices/homeSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "./store";
import Backdrop from '@mui/material/Backdrop';

const App = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      dispatch(set({
        Name: parsedUser.name,
        role: parsedUser.role,
        loginType: parsedUser.loginType
      }));
    }
  }, [dispatch]);
  // const storedUser = localStorage.getItem("user");
  // if (storedUser) {
  //   const parsedUser = JSON.parse(storedUser);
  //   dispatch(set({
  //     Name: parsedUser.name,
  //     role: parsedUser.role,
  //     loginType: parsedUser.loginType
  //   }));
  // }

  const { isLoader } = useSelector((state: any) => (console.log("state", state), {
    isLoader: state?.Loader?.isLoader,
  }));

  return (
    <div className="App">
      {isLoader && (
        <Backdrop className="loaderBackdrop" open>
          <div className="loader" role="status" aria-label="Loading">
            <span />
            <span />
            <span />
            <span />
          </div>
        </Backdrop>
      )}
      <SuccessSnackbar />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="Superadmin/*" element={<SuperAdminDashBoard />} />
        <Route path="admin/*" element={<AdminDashboard />} />
        <Route path="cxo/*" element={<CxoDashboard />} />
        <Route path="publication/*" element={<PublicationDashBoard />} />
      </Routes>
    </div>
  );
};

export default App;
